import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@/components/ui-v2';

export interface RemoveMemberModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    memberName: string;
    memberEmail: string;
    orgName: string;
    submitting?: boolean;
}

export default function RemoveMemberModal({
    open,
    onClose,
    onConfirm,
    memberName,
    memberEmail,
    orgName,
    submitting,
}: RemoveMemberModalProps) {
    const [confirmText, setConfirmText] = useState('');
    const matches = confirmText.trim() === orgName;

    return (
        <Modal open={open} onClose={onClose} width={460}>
            <ModalHeader onClose={onClose}>Remove from organization</ModalHeader>
            <ModalBody>
                <p className="text-sm text-gray-800 mb-3">
                    Remove <span className="font-medium">{memberName}</span> ({memberEmail}) from{' '}
                    <span className="font-medium">{orgName}</span>?
                </p>
                <ul className="text-xs text-gray-600 list-disc pl-5 space-y-1.5 mb-4">
                    <li>They'll lose access to every workspace in this organization.</li>
                    <li>Pending invites for them in this organization will not be cancelled.</li>
                    <li>They'll receive an email about the removal.</li>
                </ul>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                    Type <span className="font-mono text-gray-900">{orgName}</span> to confirm
                </label>
                <input
                    type="text"
                    value={confirmText}
                    onChange={(e) => setConfirmText(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
                    autoFocus
                />
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={onClose} disabled={submitting}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={!matches || submitting}>
                    {submitting ? 'Removing…' : 'Remove from organization'}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
